import React, { useEffect } from 'react';
import { NavLink, Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import classnames from "classnames";
import {
  Container, Row, Col, Card, CardHeader, CardBody,
  Nav, NavItem, ButtonGroup, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem
} from "reactstrap";
import Preview from '../FeedLibrary/Preview';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { getFeedInfoSuccess, setIsChangesMade, setPreview, setSourceDataFields, setUsingCampaigns } from '../../../slices/feeds/reducer';
import { getFeedInfo, getFeeds, getPreviewInfo, loadSource, updateFeed } from '../../../slices/feeds/thunk';
import { setFeedModalType, toggleCreateFeedModal, toggleSelectPathModal } from '../../../slices/modals/reducer';
import { setPreloader } from '../../../slices/layouts/reducer';
import { replace } from "redux-first-history";
import checkPermission from '../../../Components/Hooks/PermissionHook';
import AddSortingFiltersBtn from './AddSortingFiltersBtn';
import AddFieldBtn from './AddFieldBtn';
import SaveFeedBtn from './SaveFeedBtn';
import { setBreadcrumb } from '../../../slices/auth/menu/reducer';
import { getFeedsCampaignsData } from '../../../helpers/backend_helper';

function Feed() {
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname.split("/").pop();
  const params = useParams();

  const selectRoutePaths = createSelector((state) => state.MenuData, (state) => ({
    client: state.client,
    clientPath: state.clientPath,
    brandPath: state.brandPath,
    title: state.title
  }));
  const { client, clientPath, brandPath, title } = useSelector(selectRoutePaths);

  const selectFeedInfo = createSelector((state) => state.Feed, (state) => ({
    feedInfo: state.feedInfo,
    sourceDataFields: state.sourceDataFields,
  }));
  const { feedInfo, sourceDataFields } = useSelector(selectFeedInfo);

  const selectLocations = createSelector((state) => state.router.previousLocations, (state) => state);
  const previousLocations = useSelector(selectLocations)

  useEffect(() => {
    async function handleFeeds() {
      if (previousLocations[0].location.state === null && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP")) {
        dispatch(setPreloader(true));
        const res = await dispatch(getFeedInfo({id: params.feed}));
        const previewRes = await dispatch(getPreviewInfo(res.payload));
        const usingCampaignsRes = await getFeedsCampaignsData({feedId: params.feed});
        const usingCampaigns = (usingCampaignsRes?.data || []);
        dispatch(replace(location.pathname, { 
          feedInfo: res.payload, 
          preview: previewRes, 
          title: [{ name: res.payload.name, src: window.location.href }],
          usingCampaigns: usingCampaigns,
          sourceDataFields: sourceDataFields,
        }));
        dispatch(setPreloader(false));
      } else if (previousLocations[0].location.state !== null) {      
        dispatch(getFeedInfoSuccess(previousLocations[0].location.state.feedInfo));
        dispatch(setPreview((previousLocations[0].location.state.preview || [])));
        dispatch(setIsChangesMade(false));
        dispatch(setSourceDataFields(previousLocations[0].location.state.sourceDataFields));
        dispatch(setUsingCampaigns(previousLocations[0].location.state.usingCampaigns));
        dispatch(setBreadcrumb({pageTitle: 'Feeds', title: previousLocations[0].location.state.title}));
      }
    }
    handleFeeds();
  }, [clientPath, brandPath]);

  if (checkPermission("brands", brandPath, "feedView")) {
    return (
      <React.Fragment>
        <Row>
          <Col xxl={9} xl={8}>
            <Card>
              <CardHeader className=''>
                <Nav className="nav-tabs-custom rounded card-header-tabs border-bottom-0" role="tablist">
                  <NavItem>
                    <NavLink
                      to={`fields`}
                      className={"nav-link " + classnames({ active: path == "fields" })}
                      type="button"
                    >
                      Fields{feedInfo ? `(${feedInfo?.feed.length})` : null}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to={`sorting-filters`}
                      className={"nav-link " + classnames({ active: path == "sorting-filters" })}
                      type="button"
                    >
                      Sorting&Filters{feedInfo !== null ? `(${feedInfo.operations.length})` : null}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to={`usage`}
                      className={"nav-link " + classnames({ active: path == "usage" })}
                      type="button"
                    >
                      Usage
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      to={`settings`}
                      className={"nav-link " + classnames({ active: path == "settings" })}
                      type="button"
                    >
                      Settings
                    </NavLink>
                  </NavItem>
                  <div className='d-flex gap-1 ms-auto me-0 my-auto'>
                    {path === "fields" ?
                      <AddFieldBtn />
                      : null}
                    {path === "sorting-filters" && (feedInfo?.operations.length > 0 || false) ?
                      <AddSortingFiltersBtn />
                      : null}
                    <SaveFeedBtn />
                  </div>
                </Nav>
              </CardHeader>
              <CardBody>
                <Outlet />
              </CardBody>
            </Card>
          </Col>
          <Col xxl={3} xl={4}>
            <Preview reload={true} />
          </Col>
        </Row>
      </React.Fragment>
    )
  } else {
    return <Navigate to={"/out-of-permission"} />
  }

}

export default Feed
